
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartPlus } from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';

const Players = (props) => {
    const { name, username, img,club, earning} = props.data;
    const addHandleClick = props.addHandleClick;
    return (
        
            <div className='row mb-2 row-cols-2'>
                <div className='col-md-4'>
                    <div>

                        <div className="card" >
                            <img src={img} className="card-img-top" alt="..."/>
                            <div className="card-body">
                                <h5 className="card-title text-center">{name}</h5>
                                
                                <a href={img} className="btn btn-outline-info btn-sm align-self-center" target="_blank" rel="noreferrer"> >view Image</a>
                        </div>
                    </div>

                        
                    </div>
                </div>
                    <div className='bg-white col-md-8 '>
                       <div className='text-center mt-5'>
                                <h4 style={{color:"#0033FF",}}>{name}</h4>
                                <p><small>User Name: {username}</small></p>
                                <p><small>Club Name: {club.name}</small></p>
                                <p><small>earning: ${earning}</small></p>
                                <img src={club.img} alt="" srcset="" />


                                <button className="btn btn-outline-success" onClick={()=> addHandleClick(props.data)}><FontAwesomeIcon icon={faCartPlus} /> Add To Cart</button>
                       </div>
                    </div>
            </div>


           
        
    );
};

export default Players;